import { useState } from 'react'

export default function Contact() {
  const [status, setStatus] = useState(null)
  const [submitting, setSubmitting] = useState(false)

  async function handleSubmit(e) {
    e.preventDefault()
    setSubmitting(true)
    setStatus(null)
    try {
      const res = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        body: new FormData(e.target),
      })
      const data = await res.json()
      if (data.success) {
        setStatus({ ok: true, msg: 'Thank you! Your message has been sent.' })
        e.target.reset()
      } else {
        setStatus({ ok: false, msg: 'Something went wrong. Please try again.' })
      }
    } catch {
      setStatus({ ok: false, msg: 'Something went wrong. Please try again.' })
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div className="two-col">
      <div>
        <form className="contact-form" onSubmit={handleSubmit}>
          <input type="hidden" name="access_key" value="d687ddbc-1697-4c3b-8caa-fcee2d907d67" />
          <input type="hidden" name="subject" value="New message from sailalamar.com" />
          <input type="checkbox" name="botcheck" style={{ display: 'none' }} />

          <h2>Reach Out Anytime!</h2>
          <p style={{ fontSize: 12, marginBottom: 8 }}>
            <span className="form-required">*</span> Indicates required field
          </p>

          <div className="field">
            <label>Name <span className="form-required">*</span></label>
            <div className="name-row">
              <div>
                <input type="text" name="first_name" placeholder="First" required aria-required="true" />
                <span className="sublabel">First</span>
              </div>
              <div>
                <input type="text" name="last_name" placeholder="Last" required aria-required="true" />
                <span className="sublabel">Last</span>
              </div>
            </div>
          </div>

          <div className="field">
            <label htmlFor="email">Email <span className="form-required">*</span></label>
            <input type="email" id="email" name="email" required aria-required="true" />
          </div>

          <div className="field">
            <label>What&apos;s your interest? <span className="form-required">*</span></label>
            <div className="checkbox-group">
              <label>
                <input type="checkbox" name="interest_charter" value="Charter" />
                Charter
              </label>
              <label>
                <input type="checkbox" name="interest_newsletter" value="Updates / Newsletter" />
                Updates / Newsletter
              </label>
              <label>
                <input type="checkbox" name="interest_family" value="Family & Friends Cooperative" />
                Family &amp; Friends Cooperative
              </label>
            </div>
          </div>

          <div className="field">
            <label htmlFor="message">Please share your thoughts: <span className="form-required">*</span></label>
            <textarea id="message" name="message" required aria-required="true" />
          </div>

          {status && (
            <div
              className="form-result"
              style={{ color: status.ok ? '#2a7a2a' : '#b00' }}
            >
              {status.msg}
            </div>
          )}

          <div style={{ marginTop: 10 }}>
            <button className="btn" type="submit" disabled={submitting}>
              {submitting ? 'Sending...' : 'Submit'}
            </button>
          </div>
        </form>
      </div>

      <div style={{ textAlign: 'center', paddingTop: 10 }}>
        <img
          src="https://web.archive.org/web/20240425032440im_/http://www.sailalamar.com/uploads/1/2/8/8/12888984/1201725_orig.jpg"
          alt="ALAMAR"
          style={{ maxWidth: '100%', height: 'auto' }}
        />
      </div>
    </div>
  )
}
